import * as React from 'react';
import { connect } from 'react-redux';

import { postEnvoiMailServiceAchat } from 'utils/posters';

import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import LoadingButton from '@mui/lab/LoadingButton';
import TextField from '@mui/material/TextField';

import SendIcon from '@mui/icons-material/Send';

const formControlStyle = theme => ({
    width: '100%',
    marginBottom: theme.spacing(1)
});


const EnvoiMailServiceAchat = ({ fournisseur, open, onClose, postEnvoiMailServiceAchat }) => {

    // Hook message du mail
    const [messageMail, setMessageMail] = React.useState('');

    /** Hook loading */
    const [loading, setLoading] = React.useState(false);

    // Handler de fermeture de la popin
    const handleOnClose = () => {
        setMessageMail('');
        onClose();
    }

    // Handler pour l'envoi d'un mail
    const handleSendMail = async () => {
        setLoading(true);

        let response = await postEnvoiMailServiceAchat(fournisseur.id, messageMail);

        if (response) {
            setLoading(false);
            handleOnClose();
        }
    }

    if (fournisseur === undefined || fournisseur === null)
        return null;

    return (
        <>
            <Dialog
                fullWidth
                maxWidth={'md'}
                sx={{ maxHeight: '90vh' }}
                open={open}
                onClose={(event, reason) => {
                    if (reason !== 'backdropClick') {
                        handleOnClose();
                    }
                }}
            >
                <DialogTitle>
                    Envoyer un mail au Service Achat (info-sav@foussier.fr)
                </DialogTitle>

                <DialogContent>

                    <DialogTitle>
                        Message concernant le fournisseur {fournisseur.code} - {fournisseur.nom}
                    </DialogTitle>

                    <TextField
                        multiline
                        sx={formControlStyle}
                        value={messageMail}
                        onChange={e => setMessageMail(e.target.value)}
                        variant="filled"
                        label="Message"
                        placeholder="Veuillez saisir votre message"
                        InputLabelProps={{
                            shrink: true,
                        }}
                        rows={4}
                        disabled={loading}
                    />

                    <DialogActions>
                        <Button
                            onClick={handleOnClose}
                            color="primary"
                        >
                            Annuler
                        </Button>

                        <LoadingButton
                            disabled={messageMail === ''}
                            onClick={handleSendMail}
                            variant="contained"
                            color="secondary"
                            endIcon={<SendIcon />}
                            loading={loading}
                            loadingPosition="end"
                        >
                            Envoyer
                        </LoadingButton>

                    </DialogActions>

                </DialogContent>

            </Dialog>
        </>
    );
}
const mapDispatchToProps = {
    postEnvoiMailServiceAchat
};

export default connect(null, mapDispatchToProps)(EnvoiMailServiceAchat);